export enum RouteName {
  List = 'list-point-of-interactions',
}
